//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/Builder.js";
import "../Features/Features.FeatureReferencesBuilder.js";
import "../Features/Features.SelectFeatureList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CopyReplacementFeature",1,0],[0,"DeleteOriginalFeature",1,0],[0,"DisplayUniqueInputsToMap",1,0],[0,"DoAutomaticGeomMatch",1,0],[1,"FeatureReferences",0,"Features.FeatureReferencesBuilder",0],[0,"IsMappingToleranceIncreased",1,0],[0,"KeepFeatureToReplace",1,1],[0,"MappingMethod",1,0],[0,"MappingTolerance",1,0],[1,"ReplacementFeature",0,"Features.SelectFeatureList",0],[1,"SelectFeature",0,"Features.SelectFeatureList",0]],[[["indices","matchingTag"],"SetMatchingForIndex",{},2,0],[["parentTag","matchingTag"],"SetMatchingForParent",{},2,0],[[],"UpdateMap",{},0,0],[[],"AutomatchMap",{},0,0]],[]];
SPLM.Features.ReplaceFeatureBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ReplaceFeatureBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ReplaceFeatureBuilder.MappingMethodType = Object.freeze({
    "MapOnlyObjectsWithModelingDependencies" : "MapOnlyObjectsWithModelingDependencies", "MapAllObjects" : "MapAllObjects"});

export default SPLM;